import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { MenuItem } from '@src/common/components/Menu';
import {
  actionIconStyle,
  menuItemStyle,
} from '@src/orders/components/permitList/PermitActions/PermitActionsStyles';
import { ReplacePermitTypeModal } from '@src/orders/components/permitList/PermitActions/ReplacePermitTypeModal';
import { useNavigateToReplacePermitType } from '@src/orders/components/permitList/PermitActions/ReplacePermitTypeNavigationState';
import type { PermitSummary } from '@src/orders/domain/PermitSummary';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends ComponentPropsWithoutRef<typeof MenuItem> {
  permit: PermitSummary;
  orderId: string;
}

export const ReplacePermitType = forwardRef<HTMLLIElement, Props>(
  ({ permit, orderId, ...menuItemProps }, ref) => {
    const { t } = useTranslation();
    const { navigateToReplacePermitType } = useNavigateToReplacePermitType();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleConfirm = (note?: AddNoteRequest) => {
      setIsModalOpen(false);
      navigateToReplacePermitType({ note, permit, orderId });
    };

    return (
      <>
        <MenuItem
          {...menuItemProps}
          ref={ref}
          className={menuItemStyle}
          onClick={() => setIsModalOpen(true)}
        >
          <SwapHorizIcon style={actionIconStyle} />
          {t('permitApplication.replaceType.action')}
        </MenuItem>
        <ReplacePermitTypeModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleConfirm}
          permit={permit}
        />
      </>
    );
  },
);
